import { MarkerF, MarkerClusterer, OverlayView } from '@react-google-maps/api';
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {LocalLanguage} from "@/types_and_interfaces/types.ts";
import CMS from "@/utils/cms.ts";
import CommonClass from "@/utils/common.ts";
import Images from "@/utils/images.ts";
import eventEmitter from "@/utils/event_emmiter_instance.ts";

const MapMarkers = () => {
    
    const chisinauCoordinates = {
        lat: 47.023,
        lng: 28.842
    };
    
    const { i18n} = useTranslation()
    const offices = CMS.offices.offices
    const [selectedLocation, setSelectedLocation] = useState<any>({})
    
    const setLocationsHandler = (loc:any) => {
        setSelectedLocation(loc);
    }
    
    const langAwareOffices = () => {
        
        if(!offices) return
        
        return offices.map((off:any) => CMS.langAwareFilter(off, (i18n.language as LocalLanguage)))
        
    }
    
    const filtered_offices = langAwareOffices()
    
    
    useEffect(() => {
        
        eventEmitter.on(CommonClass.CustomEvents.set_map_location, setLocationsHandler)
        
        return () => {
            eventEmitter.off(CommonClass.CustomEvents.set_map_location, setLocationsHandler)
        }
        
    }, []);
    
    
    
    return (
        
        <OverlayView
            position={chisinauCoordinates}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
        >
            {Array.isArray(filtered_offices) && filtered_offices.length ? (
                <MarkerClusterer
                    zoomOnClick={true}
                >
                    {(clusterer) =>
                        <>
                            {filtered_offices.map((loc: any, i: number) => {
                                let icon = {
                                    url: Images.map.MarkerSelected,
                                };
                                
                                if (typeof selectedLocation === "object" && Object.keys(selectedLocation).length) {
                                    if (loc.city_name === selectedLocation?.city_name && loc.address === selectedLocation?.address) {
                                        icon = {
                                            url: Images.map.MarkerSelected,
                                        };
                                    } else {
                                        icon = {
                                            url: Images.map.Marker,
                                        };
                                    }
                                }
                                
                                return (
                                    <MarkerF
                                        key={"marker" + i}
                                        position={CommonClass.convertCoordinatesToLatLng(loc.coordonates)}
                                        icon={icon}
                                        clusterer={clusterer}
                                    />
                                );
                            })}
                        </>
                    }
                </MarkerClusterer>
            ) : null}
        </OverlayView>
            
        
    )
}

export default MapMarkers